import React from 'react';

type MemoriesIconProps = {
  fill?: string;
  stroke?: string;
  width?: string;
  height?: string;
};

function MemoriesIcon({
  fill = 'none',
  stroke = '#6267AC',
  width = '24',
  height = '25',
}: MemoriesIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 25'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M18.0531 6.76018L18.0666 6.74676L17.9993 6.59091C16.1652 2.34244 12.0377 2.25 11.6398 2.25H11.6098C11.1918 2.25 7.07433 2.34244 5.24024 6.59091L5.23998 6.59152L5.23915 6.59344C5.1639 6.76886 3.63987 10.3213 6.38511 13.537C6.44345 13.6141 6.55191 13.7731 6.64545 13.9579C6.7444 14.1534 6.80976 14.3453 6.80976 14.49V16.56C6.80976 17.3492 7.07987 18.0903 7.58976 18.6935V18.88V19.11V19.26H7.58937L7.59016 19.2741C7.67751 20.8245 8.9552 22.06 10.5298 22.06H12.6898C14.2643 22.06 15.542 20.8245 15.6294 19.2741L15.6298 19.2741V19.26V19.12V18.88V18.7033C16.1303 18.1091 16.4098 17.3594 16.4098 16.57V14.5C16.4098 14.3553 16.4751 14.1634 16.5738 13.9697C16.6685 13.7837 16.7774 13.6275 16.8319 13.5599C19.3075 10.6646 18.3335 7.505 18.0531 6.76018ZM12.6898 20.79H10.5398C9.74664 20.79 9.08367 20.2405 8.90245 19.5H14.3271C14.1459 20.2405 13.4829 20.79 12.6898 20.79ZM15.8698 12.7475L15.8707 12.7483C15.8108 12.8204 15.6492 13.0371 15.4972 13.3262C15.3358 13.6332 15.1698 14.0508 15.1698 14.48V16.55C15.1698 17.0947 14.9654 17.6008 14.573 17.9932L14.463 18.1032L14.3898 18.1764V18.23H8.82807L8.82054 18.1472L8.75654 18.0832L8.64654 17.9732L8.46976 18.15L8.64654 17.9732C8.2757 17.6024 8.06976 17.097 8.06976 16.54V14.47C8.06976 14.0359 7.90385 13.6184 7.74066 13.3104C7.57799 13.0035 7.40337 12.7783 7.34814 12.7156C5.15697 10.1688 6.28467 7.35082 6.3874 7.0941C6.38872 7.0908 6.38987 7.08792 6.39085 7.08547C7.69748 4.06352 10.309 3.58643 11.2574 3.51938L11.2574 3.51948L11.2646 3.51876C11.4523 3.49999 11.573 3.5 11.5992 3.5H11.5998L11.6296 3.5L11.6297 3.5H11.6297L11.6297 3.5L11.6298 3.5L11.6306 3.5L11.635 3.50003L11.6536 3.50028C11.6701 3.50056 11.6946 3.50114 11.7252 3.50232C11.7864 3.50467 11.8712 3.50939 11.9649 3.51876L11.9649 3.51886L11.9721 3.51938C12.9206 3.58644 15.5339 4.0637 16.8401 7.09883L16.8404 7.09873C16.9463 7.36467 18.0462 10.2038 15.8698 12.7475Z'
        fill='#6267AC'
        stroke={stroke}
        strokeWidth='0.5'
      />
    </svg>
  );
}

export default MemoriesIcon;
